import defaultSettings from '@/settings';

const title = defaultSettings.title;

export function getPageTitle(pageTitle) {
    if (pageTitle === 'landing') {
        return 'Smartdrone';
    }
    if (pageTitle) {
        return `${pageTitle} | ${title}`;
    }
    return `${title}`;
}

export function getTicketId(ticket) {
    var returnValue = '';
    var id = String(ticket.id);
    if (ticket.issueType && (ticket.issueType.toUpperCase() === 'P' || ticket.issueType.toUpperCase() === 'PRESUPUESTO')) {
        returnValue += ticket.issueType.charAt(0).toUpperCase();
    }
    while (id.length < 6 - returnValue.length) {
        id = '0' + id;
    }
    returnValue += id;

    return returnValue;
}

export function formatDate(date, withTime) {
    var dateArray, retVal = '';
    if (date) {
        dateArray = date.split('T')[0].split('-');
        retVal = dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0];

        if (withTime) {
            retVal += ' ' + date.split('T')[1].substr(0, 8);
        }
    }
    return retVal;
}
